import { render, staticRenderFns } from "./error-goods-popup.vue?vue&type=template&id=0ebc6306&scoped=true&"
import script from "./error-goods-popup.vue?vue&type=script&lang=js&"
export * from "./error-goods-popup.vue?vue&type=script&lang=js&"
import style0 from "./error-goods-popup.vue?vue&type=style&index=0&id=0ebc6306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc6306",
  null
  
)

export default component.exports